export default __webpack_public_path__ + "static/media/avatar-s-3.5f763e4d.jpg";